import gql from 'graphql-tag';

export const  question_query = gql`
  query question($presentation_id: String) {
  questions: question(where: {presentation_id: {_eq: $presentation_id}, visible: {_eq: true}}, order_by: {order: asc}) {
    id
    question
    image
    order
    options(order_by: {order: asc}) {
      id
      correct
      option
      order
    }
    visible
    video_id
    video_token
    active_media
  }
}
`;

export const  question_subscription = gql`
  subscription question($presentation_id: String) {
  questions: question(where: {presentation_id: {_eq: $presentation_id}, visible: {_eq: true}}, order_by: {order: asc}) {
    id
    question
    image
    order
    options(order_by: {order: asc}) {
      id
      correct
      option
      order
    }
    responses {
      options {
        question_option_id
        question_response_id
        
      }
    }
    visible
    video_id
    video_token
    active_media
  }
}
`;

export const presentation_by_pk = gql`
  query presentation_by_pk($id: String!) {
    presentation_by_pk(id: $id) {
      id
      live
      questions_from_time
      questions_to_time
      results_from_time
      results_to_time
      timer
    }
  }
`
export const leaderboard = gql`
    subscription (
      $presentation_id: String!
    ) {
      leaderboard (where: {
        presentation_id: {
          _eq: $presentation_id
        }
      }, order_by: {
        points: desc
      }) {
        user {
          id
          photo
          name
        }
        points
      }
    }
  `

export const leaderboard_query = gql`
    query leaderboard_query (
      $presentation_id: String!
    ) {
      leaderboard (where: {
        presentation_id: {
          _eq: $presentation_id
        }
      }, order_by: {
        points: desc
      }) {
        user {
          id
          photo
          name
        }
        points
      }
    }
  `
export const quiz_actions = gql`
subscription ($presentation_id: String!) {
  quiz_actions(where: {presentation_id: {_eq: $presentation_id}}) {
    action
    answered_count
    connected_user_count
    id
    question_index
  }
}`


export const quiz_actions_query =`
query ($presentation_id: String!) {
  quiz_actions(where: {presentation_id: {_eq: $presentation_id}}) {
    action
    answered_count
    connected_user_count
    id
    question_index
  }
}`

export const quiz_users = gql`
subscription ($presentation_id: String!) {
  quiz_users(where: {presentation_id: {_eq: $presentation_id}}) {
    name
    presentation_id
    user_id
  }
}`

export const INSERT_QUIZ_ACTION = gql`mutation update_quiz_actions($presentation_id: String!, $action: String!) {
  update_quiz_actions(where: {presentation_id: {_eq: $presentation_id}}, _set: {action: $action}) {
    affected_rows
  }
}
`


